// The Lobby's « Rang » tab: the player's rank, record and the ladder, or the 50 best players.
import React, { useState } from "react";
import { MyRank, Leaderboard } from "../rank/RankViews";
import { PlayerCardDialog } from "../players/PlayerCardDialog";
import { t } from "../../lib/i18n";

export function Segments({ value, onChange, items, testId }) {
  return (
    <div role="tablist" className="mx-auto grid max-w-sm gap-1 rounded-full border border-white/[0.06] bg-slate-950/70 p-1" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
      {items.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={value === id}
          onClick={() => onChange(id)}
          data-testid={`${testId}-${id}`}
          className={`rounded-full py-1 text-[11px] uppercase tracking-[0.12em] transition-colors ${value === id ? "bg-amber-400 text-slate-950" : "text-slate-400 hover:text-white"}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export function RankTab({ rank }) {
  const [view, setView] = useState("me");
  const [cardOf, setCardOf] = useState(null);
  return (
    <div className="mx-auto max-w-xl space-y-2">
      <Segments
        value={view}
        onChange={setView}
        testId="rank-tab"
        items={[{ id: "me", label: t("rank.tabs.me") }, { id: "board", label: t("rank.tabs.board") }]}
      />
      <section className="rounded-2xl border border-white/[0.07] bg-slate-900/80 p-3 shadow-[0_6px_24px_rgba(0,0,0,0.3)]">
        {view === "me" ? <MyRank rank={rank} /> : <Leaderboard onOpen={setCardOf} />}
      </section>
      <PlayerCardDialog userId={cardOf} onClose={() => setCardOf(null)} />
    </div>
  );
}

export default RankTab;
